export default {
  enabled: { us: true, gb: false },
  careerLink:
    'https://www.copart.com/content/us/en/landing-page/car-transport-driver-jobs-cdl#self_serv_kiosk',
  headerText: 'Copart is hiring 200 drivers to transport cars.',
  mainText: ['Great Pay. Great Company.', 'We Pay for Training']
}
